import { Component, OnDestroy, OnInit } from '@angular/core';

import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { EmployeeService } from '@app/cp/shared/services/employee.service';
import { Subscription } from 'rxjs';

import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';

import { CommonFunctions } from '../../shared/static/common-functions';
import { AppSettings } from '../../shared/models/AppSettings';
import { CommonValues } from '@app/cp/shared/static/CommonValues';

@Component({
    selector: 'user-setting',
    templateUrl: './user-setting.component.html',
    styleUrls: ['./user-setting.component.scss']
})
export class UserSettingDialogComponent  implements OnInit, OnDestroy {

    constructor(private svc_data: EmployeeService, public globals: GlobalsService) {
    }
    subs_data: Subscription;
    dataLoading: boolean = false;

    saving: boolean = false;
    data: any;
    ngOnInit() {
        this.getData();
        console.log(JSON.stringify(this.data));
        console.log(this.data);
    }
    ngOnDestroy(): void {
        CommonFunctions.unsubscribe(this.subs_data);
    }
    showSettings: boolean = false;
    toggleSettings() {
        this.settingsOn;
    }

    settingsOn() {
        this.showSettings = true;
    }
    settingsOff() {
        this.showSettings = false;
    }
    getData(): void {
        this.saving = true;

        this.dataLoading = true;
        this.subs_data = this.svc_data.GetUserSettings().subscribe(data => {
            if (!data.saveError) {
                this.data = data.primaryReturn;
                console.log(data.primaryReturn);
                console.log(JSON.stringify(data.primaryReturn));
            }

            this.saving = false;
        });
    }
    save() {

        this.svc_data.saveUserSettings(this.data).subscribe(
            data => {
                if (!data.saveError) {
                    this.saveSuccess();
                }
                else { this.saveError();}
            },
            err => { this.saveError(); }
        );

    }
    protected saveSuccess(message: string = null) {
        var settings = JSON.parse(localStorage.getItem(CommonValues.StorageKeys_UserSettings));
        var userSetttings: AppSettings = new AppSettings();
        userSetttings.setSettingsLoad(settings);
        if (Array.isArray(this.data)) {
            var searchDispatchs = this.data.find(a => a.name == "SearchDispatchs");
            if (searchDispatchs) {
                userSetttings.SearchDispatchs = searchDispatchs.value;
                    }
            else {
                userSetttings.SearchDispatchs = "";
            }
            var dispatchBoardStatusWidth = this.data.find(a => a.name == "DispatchBoardStatusWidth");
            if (dispatchBoardStatusWidth) {
                userSetttings.DispatchBoardStatusWidth = dispatchBoardStatusWidth.valueNumber;
            }
            else {
                userSetttings.DispatchBoardStatusWidth = 250;
            }

        }
        localStorage.setItem(CommonValues.StorageKeys_UserSettings, JSON.stringify(userSetttings));

        let not: string =  "Settings Successfully Saved" + (CommonFunctions.hasStringValue(message) ? " " + message : "");
        this.globals.notifySuccess(not);

    }
    protected saveError(message: string = null) {
        let not: string = "There was a problem saving Settings " + (CommonFunctions.hasStringValue(message) ? " " + message : "");
        this.globals.notifyError(not,  true);
    }
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };

}
